import React from 'react';

import TaskItemAssignmentChip from './TaskItemAssignmentChip';
import TaskItemDueDateChip from './TaskItemDueDateChip';
import TaskItemLabelChip from './TaskItemLabelChip';
import TaskItemReactionChip from './TaskItemReactionChip';
import type { ElementChipDescriptor } from '../elementChipsTypes';
import type { TaskItemChipSource, UpdateTaskItemAttrs } from '../taskItemChipsUtils';
import { ChipBaseProps } from '../../../../common/@roma/src/components/base/chip/ChipBase';

type TaskItemChipProps = {
    chip: ElementChipDescriptor;
    size: ChipBaseProps['size'];
    currentUserId?: string;
    canModify: boolean;
    /** The owning task node's chip-relevant attrs. */
    attrs: TaskItemChipSource;
    updateAttributes: UpdateTaskItemAttrs;
};

/**
 * Renders a chip descriptor for a Tiptap task item using the matching
 * node-attr-backed chip implementation.
 */
const TaskItemChip: React.FC<TaskItemChipProps> = ({
    chip,
    size,
    currentUserId,
    canModify,
    attrs,
    updateAttributes,
}) => {
    switch (chip.type) {
        case 'label':
            return (
                <TaskItemLabelChip
                    chip={chip}
                    size={size}
                    labels={attrs.labels}
                    updateAttributes={updateAttributes}
                    canModify={canModify}
                />
            );
        case 'reaction':
            return (
                <TaskItemReactionChip
                    chip={chip}
                    currentUserId={currentUserId}
                    reactions={attrs.reactions}
                    updateAttributes={updateAttributes}
                    canModify={canModify}
                />
            );
        case 'assignment':
        case 'assignment-placeholder':
            return (
                <TaskItemAssignmentChip
                    chip={chip}
                    size={size}
                    assignments={attrs.assignments}
                    updateAttributes={updateAttributes}
                    canModify={canModify}
                />
            );
        case 'due-date':
            return (
                <TaskItemDueDateChip
                    chip={chip}
                    size={size}
                    dueDate={attrs.dueDate}
                    updateAttributes={updateAttributes}
                    canModify={canModify}
                />
            );
        default:
            return null;
    }
};

export default TaskItemChip;
